import produce from "immer";
import { GET_SETTLEMENT_LIST_SUCCESS, GET_PARTY_BASED_ROLE_SUCCESS } from "src/actions/settlementActions";

const initialState = {
    settlementList: [],
    orderList:[]
};

const settlementReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SETTLEMENT_LIST_SUCCESS: {
            const settlementList = action.payload;
            return produce(state, (draft) => {
                draft.settlementList = settlementList
            });
        }
        case GET_PARTY_BASED_ROLE_SUCCESS: {
            const list = action.payload;
            return produce(state, (draft) => {
                draft.orderList = list
            });
        }
        
        default: {
            return state;
        }
    }
};

export default settlementReducer;


